import axios from "axios";
import config from "../config/index";
import { vasProductQuery, vasProductAddOrRemoveInCart } from "../config/queries";
import ajaxServices from "../utils/ajaxServices";

export const getVasItems = (dealSheetId) => {
    return new Promise((resolve, reject) => {
        let url = `${config.envConfigs[config.env].dxl.url}${config["api"]["getVASDeatilsForDeals"]
            }`;
        const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-magento-store": "cbu"
        };

        url = `${url}?dealsheetNumber=${dealSheetId}&vasProductFields=${encodeURIComponent(vasProductQuery)}`;
        axios.get(url, {
            headers: headers
        }).then(response => {
            if (response.data) {
                resolve(response.data.vas);
            }
        }).catch(error => {
            reject(error);
        });
        // resolve(vasDetails.vas);
    });
}

export const updateTheCartWithVASProduct = async (cartId, dealId, removedVas, addedVas) => {
    addedVas = addedVas.map(item => {
        const addedVases = {
            data: {
                quantity: 1,
                sku: item.vidCode
            },
            monthly_recurring: +item.price,
            parent_product_sku: dealId,
            bundle_options: []
        }

        return addedVases;
    })

    const updatedItems = await ajaxServices.fetchGraphQLPOSTRequest(vasProductAddOrRemoveInCart, {
        cart_id: cartId,
        remove_simple_products: removedVas,
        cart_items: addedVas
    });

    return updatedItems;
}

export const getVASContractCoverContent = async () => {
    const contractCoverContent = await ajaxServices.httpGet(
        "drupalBaseUrl",
        "_format=json",
        "api",
        "contractCover"
      );

    return contractCoverContent;
}
